import { capitalise } from '../../../../../utils';
import { DATE, formatDateUTC } from '../../../../../utils/date';

interface Props {
  effectiveDate?: string;
  period?: string;
  aggregated?: boolean;
}

export const TakenFromText = ({ effectiveDate, period, aggregated }: Props) => {
  const prefix = aggregated ? 'Aggregated from' : 'Taken from';
  return (
    <div className='data-evidence text-xs mt-2 text-ThemeTextPlaceholder'>
      {prefix}: {period ? `${capitalise(period)} ` : ''}
      {formatDateUTC(effectiveDate || '', DATE.MONTH_YEAR)}
    </div>
  );
};
